import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export async function saveContactMessage(message: {
  email: string;
  professionalBackground: string;
  researchInterests: string;
  heardAboutUs: string;
  message: string;
}) {
  if (!supabase) {
    console.warn('Supabase client not initialized. Contact form will only submit to Google Forms.');
    return null;
  }

  try {
    const { data, error } = await supabase
      .from('contact_messages')
      .insert([message])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving contact message to Supabase:', error);
    return null;
  }
}